import { SimpleSignal } from "../SimpleSignal";
import { NumberInput, INumberInput, IBaseNumberInputConfig } from "./NumberInput";
import { ObjectUtils } from "../data/ObjectUtils";

export interface IRangeInputConfig extends IBaseNumberInputConfig
{
	useNumberInput?: boolean;
	divClassName?: string;
	interactive?: boolean;
}

export class RangeInput implements INumberInput
{

	public changeSignal:SimpleSignal;

	private _id:string;
	private _value:number;
	private _min:number;
	private _max:number;

	private _element:HTMLElement;
	private _input:HTMLInputElement;
	private _numberInput:NumberInput = null;

	private _config:IRangeInputConfig;

	public static defaultConfig:IRangeInputConfig = {
		id: "",
		min: -Infinity,
		max: Infinity,
		precision: 0,
		step: 1,
		className: "utils-input",
		divClassName: "utils-range",
		useNumberInput: true,
		interactive: true
	};

	constructor(config:IRangeInputConfig)
	{
		this._config = ObjectUtils.mergeConfig(RangeInput.defaultConfig, config);

		this._id = this._config.id;
		this.createInput();
		this._min = this._config.min;
		this._max = this._config.max;
		this.value = this._config.value;

		this.changeSignal = new SimpleSignal();

		if (this._config.useNumberInput)
		{
			this._element = document.createElement("div");
			this._element.id = this._config.id;
			this._element.className = this._config.divClassName;
			this.createNumberInput();
			this._element.appendChild(this._input);
			this._element.appendChild(this._numberInput.element);
		}
		else
		{
			this._element = this._input;
		}
	}

	private createNumberInput()
	{
		// to use number input
		this._config.type = "number";
		this._numberInput = new NumberInput(this._config);
		this._numberInput.changeSignal.add(this.onNumberInputChange);
	}

	private onNumberInputChange = (value:number) =>
	{
		this.value = value;
		this.changeSignal.dispatch(this._value, this);
	};

	private createInput()
	{
		var config = this._config;

		this._input = document.createElement("input");
		this._input.type = "range";
		this._input.min  = config.min.toString();
		this._input.max  = config.max.toString();
		this._input.step = config.step.toString();

		this._input.addEventListener("change", this.onChange);

		if (this._config.interactive)
		{
			this._input.addEventListener("input", this.onChange);
		}
	}

	private onChange = (event:Event) =>
	{
		const value = parseFloat(this._input.value);

		if (this._numberInput)
		{
			this._numberInput.value = value;
		}

		if (!this._input.disabled && this._value !== value)
		{
			this._value = value;
			this.changeSignal.dispatch(this._value, this, event);
		}
	};

	public enable()
	{
		this._input.disabled = false;
	}

	public disable()
	{
		this._input.disabled = true;
	}

	public set value(value:number)
	{
		this._value = value;
		this._input.value = value.toFixed(this._config.precision);
		if (this._numberInput)
		{
			this._numberInput.value = value;
		}
	}

	public get value()
	{
		return this._value;
	}

	public get min()
	{
		return this._min;
	}

	public get max()
	{
		return this._max;
	}

	public get element()
	{
		return this._element;
	}

	public get id()
	{
		return this._id;
	}
}